import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnInit,
  OnDestroy,
  ViewEncapsulation,
  computed,
  signal,
  effect,
  inject,
  ChangeDetectorRef,
} from '@angular/core';
import { MI_PERFIL_ACCESS_ROLES } from '@core/constants/roles.constants';
//import { AuthService } from '@features/auth';
import { MatDialog } from '@angular/material/dialog';
//import { navItems } from '../sidebar/sidebar-data';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
//import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from '@app/material.module';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AppSettings } from '../../../config';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AuthService, CoreService, EmpresaContextService, PerfilFotoService, SessionService } from '../../../core';
import { TrabajadoresService } from '@features/trabajador/gestion-trabajador/services/trabajadores.service';
import { HasRoleDirective } from "@core/guards/has-role.directive";
import { EmpresaSelectorGlobalComponent } from '@features/configuracion/empresa/components/empresa-selector-global.component';
import { ToastNotify } from '@features/dashboard/services/toast.service';
//import { Empresa } from '@shared/models';
import { Subscription } from 'rxjs';
import { EmpresasService } from '../../../core';
interface notifications {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

@Component({
  selector: 'app-header',
  imports: [
    RouterModule,
    CommonModule,
    NgScrollbarModule,
    MaterialModule,
    MatTooltipModule,
    HasRoleDirective,
    TranslatePipe,
    EmpresaSelectorGlobalComponent,
  ],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  private readonly langStorageKey = 'nomina_lang';

  // Signal para mostrar notificación de preferencias
  showThemeNotification = signal(false);

  // Use a signal to track options for better reactivity
  private optionsSignal!: ReturnType<typeof signal<AppSettings>>;

  public languages: any[] = [
    {
      language: 'Español',
      code: 'es',
      icon: 'assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: 'assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Français',
      code: 'fr',
      icon: 'assets/images/flag/icon-flag-fr.svg',
    },
  ];

  public selectedLanguage: any = this.languages[0];

  @Output() optionsChange = new EventEmitter<AppSettings>();


  //Declaramos e inyectamos el servicio
  private sessionService = inject(SessionService);
  private trabajadoresService = inject(TrabajadoresService);
  private perfilFotoService = inject(PerfilFotoService);

  readonly avatarUrl = signal<string>('assets/images/profile/user-1.jpg');

  private actualizacionSub!: Subscription;
  private fotoActualizadaSub!: Subscription;
  private empresasService = inject(EmpresasService);
  constructor(
    private settings: CoreService,
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    public empresaContext: EmpresaContextService,
    private toastService: ToastNotify,
    private cdr: ChangeDetectorRef
  ) {
    this.translate.currentLang() || 'es';
    const savedLang = (() => {
      try {
        return localStorage.getItem(this.langStorageKey);
      } catch {
        return null;
      }
    })();

    const validLangCodes = new Set(this.languages.map((l) => l.code));
    const langCode = savedLang && validLangCodes.has(savedLang) ? savedLang : 'es';

    if (savedLang && !validLangCodes.has(savedLang)) {
      try {
        localStorage.setItem(this.langStorageKey, langCode);
      } catch {
        // ignore
      }
    }

    this.selectedLanguage = this.languages.find((l) => l.code === langCode) ?? this.languages[0];
    translate.use(langCode);

    // Initialize signal with current settings
    this.optionsSignal = signal<AppSettings>(this.settings.getOptions());

    // Subscribe to settings changes
    this.settings.notify.subscribe((options: any) => {
      this.optionsSignal.set(options as AppSettings);
    });
  }

  ngOnInit(): void {
    this.empresaContext.loadEmpresas();
    this.actualizacionSub = this.empresasService.empresasActualizadas$.subscribe(() => {
      this.empresaContext.loadEmpresas();
    });
    this.cargarFotoPerfil();
    this.fotoActualizadaSub = this.perfilFotoService.fotoActualizada$.subscribe((trabajadorId) => {
      const miTrabajadorId = this.sessionService.getCurrentUser()?.trabajador?.trabajadorId;
      if (miTrabajadorId && Number(trabajadorId) === Number(miTrabajadorId)) {
        this.cargarFotoPerfil();
      }
    });
  }

  private cargarFotoPerfil(): void {
    const trabajadorId = this.sessionService.getCurrentUser()?.trabajador?.trabajadorId;
    if (!trabajadorId) return;

    this.trabajadoresService.descargarFoto(trabajadorId).subscribe({
      next: (blob) => this.avatarUrl.set(URL.createObjectURL(blob)),
      error: () => {
        // Sin foto registrada o error al descargarla: se mantiene el avatar por defecto
      },
    });
  }
  ngOnDestroy(): void {
    if (this.actualizacionSub) {
      this.actualizacionSub.unsubscribe();
    }
    if (this.fotoActualizadaSub) {
      this.fotoActualizadaSub.unsubscribe();
    }
  }
  //options = this.settings.getOptions();
  get options() {
    return this.optionsSignal();
  }

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }

  setlightDark(theme: string) {
    this.settings.setOptions({ theme });
    this.emitOptions();
    // Mostrar notificación
    setTimeout(() => {
      this.showThemeNotification.set(true);
      this.cdr.detectChanges();
      setTimeout(() => {
        this.showThemeNotification.set(false);
        this.cdr.detectChanges();
      }, 3000);
    }, 100);
  }

  changeLanguage(lang: any): void {
    this.selectedLanguage = lang;
    this.translate.use(lang.code);
    try {
      localStorage.setItem(this.langStorageKey, lang.code);
    } catch {
      // ignore
    }
  }

  notifications: notifications[] = [
    {
      id: 1,
      img: 'assets/images/profile/user-1.jpg',
      title: 'header.notifications.romanJoinedTeam.title',
      subtitle: 'header.notifications.romanJoinedTeam.subtitle',
    },
    {
      id: 2,
      img: 'assets/images/profile/user-2.jpg',
      title: 'header.notifications.newMessage.title',
      subtitle: 'header.notifications.newMessage.subtitle',
    },
    {
      id: 3,
      img: 'assets/images/profile/user-3.jpg',
      title: 'header.notifications.newPayment.title',
      subtitle: 'header.notifications.newPayment.subtitle',
    },
    {
      id: 4,
      img: 'assets/images/profile/user-4.jpg',
      title: 'header.notifications.completedTasks.title',
      subtitle: 'header.notifications.completedTasks.subtitle',
    },
    {
      id: 5,
      img: 'assets/images/profile/user-5.jpg',
      title: 'header.notifications.romanJoinedTeam2.title',
      subtitle: 'header.notifications.romanJoinedTeam2.subtitle',
    },
  ];

  profiledd: profiledd[] = [
    {
      id: 1,
      img: 'assets/images/svgs/icon-account.svg',
      title: 'My Profile',
      subtitle: 'Account Settings',
      link: '/',
    },
    {
      id: 2,
      img: 'assets/images/svgs/icon-inbox.svg',
      title: 'My Inbox',
      subtitle: 'Messages & Email',
      link: '/',
    },
    {
      id: 3,
      img: 'assets/images/svgs/icon-tasks.svg',
      title: 'My Tasks',
      subtitle: 'To-do and Daily Tasks',
      link: '/',
    },
  ];

  apps: apps[] = [
    {
      id: 1,
      img: 'assets/images/svgs/icon-dd-chat.svg',
      title: 'Chat Application',
      subtitle: 'Messages & Emails',
      link: '/',
    },
    {
      id: 2,
      img: 'assets/images/svgs/icon-dd-cart.svg',
      title: 'eCommerce App',
      subtitle: 'Buy a Product',
      link: '/',
    },
    {
      id: 3,
      img: 'assets/images/svgs/icon-dd-invoice.svg',
      title: 'Invoice App',
      subtitle: 'Get latest invoice',
      link: '/',
    },
    {
      id: 4,
      img: 'assets/images/svgs/icon-dd-date.svg',
      title: 'Calendar App',
      subtitle: 'Get Dates',
      link: '/',
    },
    {
      id: 5,
      img: 'assets/images/svgs/icon-dd-mobile.svg',
      title: 'Contact Application',
      subtitle: '2 Unsaved Contacts',
      link: '/',
    },
    {
      id: 6,
      img: 'assets/images/svgs/icon-dd-lifebuoy.svg',
      title: 'Tickets App',
      subtitle: 'Create new ticket',
      link: '/',
    },
    {
      id: 7,
      img: 'assets/images/svgs/icon-dd-message-box.svg',
      title: 'Email App',
      subtitle: 'Get new emails',
      link: '/',
    },
    {
      id: 8,
      img: 'assets/images/svgs/icon-dd-application.svg',
      title: 'Courses',
      subtitle: 'Create new course',
      link: '/',
    },
  ];

  quicklinks: quicklinks[] = [
    {
      id: 1,
      title: 'Pricing Page',
      link: '/t',
    },
    {
      id: 2,
      title: 'Authentication Design',
      link: '/',
    },
    {
      id: 3,
      title: 'Register Now',
      link: '/',
    },
    {
      id: 4,
      title: '404 Error Page',
      link: '/',
    },
    {
      id: 5,
      title: 'Notes App',
      link: '/',
    },
    {
      id: 6,
      title: 'Employee App',
      link: '/',
    },
    {
      id: 7,
      title: 'Todo Application',
      link: '/',
    },
    {
      id: 8,
      title: 'Treeview',
      link: '/',
    },
  ];

  /** Signal del usuario autenticado (usar en template para reactividad) */
  readonly currentUserSignal = this.sessionService.currentUser;

  /** Mi perfil: colaborador + admin/super admin (misma pantalla; backend sigue limitando datos al usuario autenticado). */
  readonly showMiPerfil = computed(() =>
    this.sessionService.hasAnyRole([...MI_PERFIL_ACCESS_ROLES]),
  );

  /** Usuario autenticado actual */
  get currentUser() {
    return this.currentUserSignal();
  }

  /** Nombre completo del trabajador para mostrar en el header */
  get displayName(): string {
    const u = this.currentUser;
    if (!u) return '';
    if (u.trabajador) {
      const t = u.trabajador;
      return [t.nombre, t.apePaterno, t.apeMaterno].filter(Boolean).join(' ').trim();
    }
    return u.username ?? '';
  }

  /** Correo del trabajador/usuario para mostrar en el header */
  get displayEmail(): string {
    const u = this.currentUser;
    if (!u) return '';
    return u.trabajador?.email ?? '';
  }

  logout(): void {
    this.authService.logout();
  }

  openMiPerfil(): void {
    void this.router.navigate(['/mi-perfil']);
  }

  openConfiguracion(): void {
    void this.router.navigate(['/mi-cuenta']);
  }

  openSoporte(): void {
    void this.router.navigate(['/soporte']);
  }
}
